<template>
    <div>
        <div class="row bg-white mb-4">
            <search v-model="search" @search="fetchCompanies" placeholder="Search by company name..." />
            <div class="p-2 text-center flex">
                <input v-model="location_search" type="checkbox" />
                Search Locations
            </div>
            <div class="col">
                <button class="btn btn-sm btn-primary float-right" @click="newCompany"><i class="fa fa-plus mr-2"></i>New Company</button>
            </div>
        </div>
        <modal ref="companyModal" @hidden="close"
            ><span slot="title">{{ onEdit ? "Edit Company" : "Company Form" }}</span>
            <kiosk-company-form v-if="!onEdit" v-model="company" ref="companyForm" @saved="saved" :systemConfig="this.systemConfig" />
            <kiosk-company-edit-form
                v-if="onEdit"
                v-model="company"
                ref="companyEditForm"
                @saved="saved"
                @plans-loaded="plansLoaded = true"
            />
            <div slot="footer">
                <button class="btn btn-default" @click="close">Cancel</button>
                <button-loading class="btn btn-primary ml-2" @click="save" :loading="company.submitting" :disabled="disableSaveButton"
                    >Save
                </button-loading>
            </div>
        </modal>
        <modal ref="usersCompanyModal" @hidden="closeUsersCompany" :has-footer="false" size="lg"
            ><span slot="title" v-if="team">{{ team.name }} - Users</span>
            <kiosk-company-details :members="team.users_without_team" v-if="team" />
        </modal>
        <card>
            <card-body class="pt-0" v-if="loading">
                <card-spinner size="large" style="height: 240px" />
            </card-body>
            <card-body class="p-0" v-else>
                <kiosk-companies-table :teams="teams.data" @editCompany="editCompany" @allUsers="showUsers" />
            </card-body>
        </card>
        <pagination :meta="teams.meta" :links="teams.links" @page="fetchCompanies" />
    </div>
</template>

<script>
export default {
    props: ["systemConfig"],
    data: () => ({
        teams: [],
        page: 1,
        search: null,
        loading: true,
        company: new Form(),
        onEdit: false,
        plansLoaded: false,
        team: null,
        location_search: false,
    }),

    computed: {
        disableSaveButton() {
            return this.onEdit && this.company.billing_enabled && !this.plansLoaded;
        },
    },

    created() {
        this.loading = true;
        this.fetchCompanies();
    },

    methods: {
        fetchCompanies(page = 1) {
            this.loading = true;
            let params = { page: page, search: this.search, location_search: this.location_search };
            this.$http.get(this.$laroute.route("api.teams.index"), { params }).then(({ data }) => {
                this.loading = false;
                this.teams = data;
            });
        },

        newCompany() {
            this.$refs.companyModal.open();
            this.company = new Form({
                messenger: true,
                web_chat: false,
                appointment: false,
                google_api_enabled: false,
                providers_enabled: false,
                pay_enabled: false,
                version_three_enabled: true,
                single_contact_per_location: true,
                team_chat_enabled: false,
                schedule: false,
                messenger_unread_messages_by_user: false,
                location_phone_numbers_enabled: true,
                timezone: null,
                billing_enabled: true,
                custify_company_id: null,
                country_code_id: null,
                agency_id: null,
                twilio_message_service_sid: null,
                submit_to_twilio: false,
                patient_experience: false,
                general_survey: false,
                throttle_messaging: false,
                onboardingOptions: {
                    generateLocation: false,
                    generateReview: false,
                    generateWebchat: false,
                    location: {
                        name: "",
                        address: "",
                        latitude: 0,
                        longitude: 0,
                        zoom: 14,
                        googleUrl: null,
                        googlePlaceId: null,
                    },
                },
                owner_details: {
                    is_us_based: true,
                    first_name: "",
                    last_name: "",
                    email: "",
                    phone: "",
                    address: "",
                    address2: "",
                    city: "",
                    state: "",
                    zip: "",
                    uses_standard_profile: false,
                    business_type: "",
                    business_industry: "",
                    business_registration_number: "",
                    business_name: "",
                    business_registration_identifier: "",
                    website_url: "",
                    social_media_profile_urls: "",
                    company_type: "",
                    stock_exchange: "",
                    stock_ticker: "",
                    independent_business: true,
                    parent_team: {
                        id: "",
                        name: "",
                    },
                },
            });
        },

        editCompany(company) {
            this.onEdit = true;
            this.plansLoaded = false;
            this.$refs.companyModal.open();
            this.company = new Form(company);
        },

        showUsers(company) {
            this.$refs.usersCompanyModal.open();
            this.team = company;
        },

        save() {
            this.onEdit ? this.$refs.companyEditForm.save() : this.$refs.companyForm.save();
        },

        saved() {
            this.$alert({
                type: "success",
                title: this.onEdit ? "Company updated!" : "Company created!",
            }).then(() => {
                this.fetchCompanies();
                this.$refs.companyModal.close();
            });
        },

        close() {
            this.onEdit = false;
            this.$refs.companyModal.close();
        },

        closeUsersCompany() {
            this.$refs.usersCompanyModal.close();
        },
    },
};
</script>
